module.exports = __webpack_public_path__ + "static/media/check_inactive.8f975d36.svg";